import FormGatewayInterface from '../../Form/FormGatewayInterface';

function calculate(fn) {
  return new Function('return ' + fn)();
}

export default class CalculateUseCase {
  public formGatewayInterface

  constructor(FormGatewayInterface: FormGatewayInterface) {
    this.formGatewayInterface = FormGatewayInterface
  }

  execute(mathematicalFormula: string | undefined, precision: number | undefined): number | null {
    if (undefined === mathematicalFormula) {
      return null
    }

    const data = this.formGatewayInterface.getCurrentValueForFormId()

    const inputIds = mathematicalFormula.match(/<input_id>(.*?)<\/input_id>/g)

    if (null === inputIds) {
      return null
    }

    let formula = mathematicalFormula
    inputIds.map(id => {
      const idWithoutTag = id.replaceAll(/<\/?input_id>/g,'')
      formula = formula.replace(
        `<input_id>${idWithoutTag}</input_id>`,
        (() => {
          const raw = data.values?.[idWithoutTag];
          const num = raw === '' || raw == null ? 0 : Number(raw);
          const safeNum = Number.isFinite(num) ? num : 0;
          return safeNum.toPrecision(12);
        })()
      )
    })

    try {
      const result = calculate(formula)
      if (precision) {
        return (Number(result)) ? Number(parseFloat(result).toFixed(precision)) : 0
      }
      return (Number(result)) ? Number(parseFloat(result).toPrecision(12)) : 0
    } catch (e) {
      return null
    }
  }
}
